import { render, staticRenderFns } from "./loadingAnimation.vue?vue&type=template&id=445ff349&"
import script from "./loadingAnimation.vue?vue&type=script&lang=js&"
export * from "./loadingAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports